export interface HeroSlide {
  id: string;
  number: string;
  title: string;
  scene: string[];
  image: string;
}

export const topSlides: HeroSlide[] = [
  {
    id: "top-01",
    number: "01",
    title: "Northern Drift",
    scene: ["Arctic", "Expedition", "2026"],
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20aerial%20view%20of%20vast%20snow%20covered%20arctic%20mountain%20range%20at%20golden%20hour%2C%20soft%20pastel%20sky%20with%20warm%20peach%20and%20cream%20tones%2C%20isolated%20lone%20explorer%20figure%20on%20a%20ridge%2C%20dreamy%20painterly%20atmosphere%2C%20editorial%20travel%20photography%2C%20muted%20earth%20palette%2C%20fine%20grain%2C%20high%20detail%2C%20artistic%20composition%20with%20strong%20negative%20space&width=1600&height=1100&seq=hero-top-01&orientation=portrait",
  },
  {
    id: "top-02",
    number: "02",
    title: "Desert Bloom",
    scene: ["Sahara", "Nomad", "Sunrise"],
    image:
      "https://readdy.ai/api/search-image?query=Sweeping%20warm%20desert%20dunes%20at%20early%20sunrise%20with%20soft%20terracotta%20and%20amber%20gradient%20sky%2C%20a%20single%20silhouetted%20traveler%20with%20a%20long%20shadow%2C%20wind%20carved%20sand%20textures%2C%20painterly%20editorial%20travel%20photography%2C%20muted%20warm%20palette%2C%20fine%20grain%2C%20high%20detail%2C%20artistic%20composition%20with%20strong%20negative%20space&width=1600&height=1100&seq=hero-top-02&orientation=portrait",
  },
  {
    id: "top-03",
    number: "03",
    title: "Coastal Mirror",
    scene: ["Atlantic", "Solitude", "Dusk"],
    image:
      "https://readdy.ai/api/search-image?query=Misty%20cinematic%20coastal%20cliffs%20at%20dusk%20with%20soft%20rolling%20fog%2C%20pale%20rose%20and%20cream%20sky%2C%20a%20lone%20wanderer%20on%20the%20edge%20of%20the%20cliff%2C%20glassy%20ocean%20reflection%2C%20painterly%20editorial%20travel%20photography%2C%20muted%20palette%2C%20fine%20grain%2C%20artistic%20negative%20space%20composition%2C%20dreamy%20mood&width=1600&height=1100&seq=hero-top-03&orientation=portrait",
  },
];

export const bottomSlides: HeroSlide[] = [
  {
    id: "bot-01",
    number: "01",
    title: "Forest Whisper",
    scene: ["Pacific", "Canopy", "Dawn"],
    image:
      "https://readdy.ai/api/search-image?query=Dense%20misty%20pacific%20rainforest%20at%20dawn%20with%20soft%20golden%20light%20filtering%20through%20ancient%20pine%20canopy%2C%20a%20small%20cabin%20with%20warm%20glowing%20window%2C%20painterly%20editorial%20travel%20photography%2C%20muted%20warm%20palette%2C%20cream%20and%20moss%20tones%2C%20fine%20grain%2C%20high%20detail%2C%20artistic%20composition%20with%20strong%20negative%20space&width=1600&height=1100&seq=hero-bot-01&orientation=portrait",
  },
  {
    id: "bot-02",
    number: "02",
    title: "Volcanic Quiet",
    scene: ["Iceland", "Geo", "Steam"],
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20volcanic%20black%20sand%20plains%20with%20steam%20rising%20from%20geothermal%20vents%2C%20a%20solitary%20traveler%20walking%20into%20the%20distance%2C%20soft%20cream%20and%20warm%20amber%20sky%2C%20painterly%20editorial%20travel%20photography%2C%20muted%20palette%2C%20fine%20grain%2C%20high%20detail%2C%20artistic%20composition%20with%20strong%20negative%20space&width=1600&height=1100&seq=hero-bot-02&orientation=portrait",
  },
  {
    id: "bot-03",
    number: "03",
    title: "Salt Lake Echo",
    scene: ["Andes", "Salt", "Mirror"],
    image:
      "https://readdy.ai/api/search-image?query=Endless%20mirror%20like%20salt%20flats%20under%20a%20soft%20pastel%20sky%20with%20cream%20and%20rose%20tones%2C%20perfect%20reflection%20of%20a%20distant%20lone%20figure%20walking%2C%20surreal%20painterly%20editorial%20travel%20photography%2C%20muted%20warm%20palette%2C%20fine%20grain%2C%20high%20detail%2C%20artistic%20composition%20with%20strong%20negative%20space&width=1600&height=1100&seq=hero-bot-03&orientation=portrait",
  },
];